export default "__VITE_ASSET__c4b9d843__"